import { ReactNode, useState } from "react";
import { IPopupOptions, Popup } from "devextreme-react/popup";
import EditorActionFooter, {
  EditorActionButtonProp,
} from "../../EditorActionFooter";
import "../styles/Controls.css";
import Loader from "../../../common/controls/Loader";

export interface Props extends IPopupOptions {
  className?: string;
  children?: ReactNode;
  displayDefaultActions?: boolean;
  onCancel?: () => void;
  onApply?: () => void;
  onClose?: () => void;
  defaultActionProp?: EditorActionButtonProp;
  isLoading?: boolean;
}

export default function PromineoModalWithLoader(props: Props) {
  const {
    title,
    className,
    visible,
    children,
    displayDefaultActions,
    defaultActionProp,
    onClose,
    isLoading,
    ...rest
  } = props;

  const [isVisible, setIsVisible] = useState(visible);

  const Footer = () => {
    const handleCancel = () => {
      defaultActionProp?.onCancel?.();
      setIsVisible(false);
      onClose?.();
    };

    const handleApply = () => {
      defaultActionProp?.onApply?.();
      setIsVisible(false);
      onClose?.();
    };

    return (
      <div className="mt-7 flex justify-end">
        <EditorActionFooter
          {...defaultActionProp}
          onCancel={handleCancel}
          onApply={handleApply}
        />
      </div>
    );
  };

  const Title = () => {
    return <div className="text-2xl font-bold font-inter mb-6">{title}</div>;
  };

  return isVisible ? (
    <div className="prom-popup">
      <Loader isVisible={isLoading} />
      <Popup
        visible={isVisible}
        dragEnabled={false}
        closeOnOutsideClick={false}
        showCloseButton={false}
        container="html"
        minWidth={400}
        minHeight={100}
        position={"center"}
        showTitle={false}
        className={`${className ?? ""}`}
        {...rest}
      >
        <div className="p-2.5">
          {title && <Title />}
          {children}
          {displayDefaultActions !== false && <Footer />}
        </div>
      </Popup>
    </div>
  ) : (
    <></>
  );
}
